import { DateTime } from '@/plugins/luxon';

const DATE_FORMATS = {
  FRONTEND: {
    DATE: 'yyyy-MM-dd',
  },
  BACKEND: {},
};

const { FRONTEND } = DATE_FORMATS;

const getDate = (date) => DateTime.fromISO(date).toFormat(FRONTEND.DATE);
const isTodayGreaterCompared = (date) => {
  const today = DateTime.now().toFormat(FRONTEND.DATE);
  const comparedDate = DateTime.fromISO(date).toFormat(FRONTEND.DATE);

  return today > comparedDate;
};

export { getDate, isTodayGreaterCompared };
